import CheckInIndexVue from "@/views/check-in/CheckInIndex.vue";

const checkin = [
  {
    path: "/checkin",
    name: "checkin",
    component: CheckInIndexVue,
    meta: {
      layout: "default",
      role: ["superadmin","backoffice","receptionist","supervisor"],
      public: false,
    },
  },
];

export default checkin;
